/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_TypesInputs */

const vi_shop_home_link_types = /** @type {(inputs: Shop_Home_Link_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại sản phẩm`)
};

/**

* @param {Shop_Home_Link_TypesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_types = /** @type {((inputs?: Shop_Home_Link_TypesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_TypesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_types(inputs)
});